module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBg0DDihDAgZ5AAAAV0lEQVRIx+2VsQnAMAwEhfbxUl4prQuT8TKEL4UDAXeSgpvo+j/46kQWUBpVvKB0YDgVKCcTn4KDF4+CwpWKVPxUoWbf5gs5z/n++RdhiaYtHNdHYcr7De4JxzOzcvXFAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA2LTEzVDAzOjE0OjQwKzAyOjAwq2TYaAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNi0xM1QwMzoxNDo0MCswMjowMNo5YNQAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/keyboard-right-arrow-button.png
// module id = 208
// module chunks = 0